import React, { ReactElement } from 'react'
import { VaultWallet as Wallet } from '@/database/vaultwallet'
import BaseWallet from './BaseWallet'

const VaultWallet = React.memo(({ wallet }: { wallet: Wallet }): ReactElement => {
    return <BaseWallet wallet={wallet} title="VAULT WALLET" />
})

VaultWallet.displayName = 'VaultWallet'

export default VaultWallet
